import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "../components/modules/BalaceTabContent/ui.helpers";

const BalancesUIContext = createContext();

export function useBalancesUIContext() {
  return useContext(BalancesUIContext);
}

export const BalancesUIConsumer = BalancesUIContext.Consumer;

export function BalancesUIProvider({ children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);

  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }
      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }
      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
  };

  return (
    <BalancesUIContext.Provider value={value}>
      {children}
    </BalancesUIContext.Provider>
  );
}
